import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { n0 } from "../../lib/format";
import { addDays, iso, monthEnd, monthStart } from "../../lib/dates";
import { Notice, Pager, Stat } from "../../lib/ui";

/* End of Day history – port of end_of_day_history.php (API: /api/eod/history). Each row opens its details. */

const t = new Date(), lm = addDays(monthStart(t), -1);
const PRESETS = [["Today", iso(t), iso(t)], ["Last 7 days", iso(addDays(t, -7)), iso(t)], ["This month", iso(monthStart(t)), iso(t)], ["Last month", iso(monthStart(lm)), iso(monthEnd(lm))]];
const vTone = (v) => (v > 0 ? "var(--up)" : v < 0 ? "var(--danger)" : "var(--muted)");

export default function EodHistory() {
  const api = useApi();
  const [f, setF] = useState({ date_from: "", date_to: "", page: 1 });
  const [form, setForm] = useState(f);
  const [d, setD] = useState(null);
  const [error, setError] = useState(null);
  const load = useCallback(async (q) => { try { setD(await api.get("/api/eod/history", q)); } catch (e) { setError(e.message); } }, [api]);
  useEffect(() => { load(f); }, [load, f]);
  const s = d?.stats;
  return (
    <main className="pg">
      <PageHeader slug="end_of_day_history" actions={<Link to="/end_of_day" className="btn primary"><i className="fas fa-moon" /> Close today</Link>} />
      <Notice notice={error && { tone: "err", text: error }} />
      <section className="panel" style={{ marginBottom: "1.25rem" }}>
        <div className="presets">{PRESETS.map(([l, a, b]) => <button key={l} type="button" aria-pressed={f.date_from === a && f.date_to === b}
          onClick={() => { setForm({ date_from: a, date_to: b }); setF({ date_from: a, date_to: b, page: 1 }); }}>{l}</button>)}</div>
        <form className="toolbar" style={{ borderBottom: 0 }} onSubmit={(e) => { e.preventDefault(); setF({ ...form, page: 1 }); }}>
          <div className="field"><label htmlFor="eh-f">From</label><input id="eh-f" type="date" value={form.date_from} onChange={(e) => setForm({ ...form, date_from: e.target.value })} /></div>
          <div className="field"><label htmlFor="eh-t">To</label><input id="eh-t" type="date" value={form.date_to} onChange={(e) => setForm({ ...form, date_to: e.target.value })} /></div>
          <button type="submit" className="btn primary">Filter</button>
          {(f.date_from || f.date_to) && <button type="button" className="btn" onClick={() => { setForm({ date_from: "", date_to: "" }); setF({ date_from: "", date_to: "", page: 1 }); }}>Clear</button>}
        </form>
      </section>
      {s && (
        <div className="ui-stats">
          <Stat icon="fa-moon" tone="muted" label="Closings" value={n0(s.total_closings)} />
          <Stat icon="fa-coins" label="Cash handled" value={n0(s.total_cash_handled)} unit="TZS" />
          <Stat icon="fa-arrow-up" tone="up" label="Surplus days" value={n0(s.surplus_count)} />
          <Stat icon="fa-arrow-down" tone="danger" label="Shortage days" value={n0(s.shortage_count)} />
          <Stat icon="fa-scale-balanced" tone="warn" label={`Balanced ${n0(s.balanced_count)} · avg variance`} value={n0(s.avg_variance)} unit="TZS" />
        </div>
      )}
      <section className="panel">
        <div className="tbl-wrap"><table className="tbl">
          <thead><tr><th>Date</th><th>Cashier</th><th className="num">Transactions</th><th className="num">Expected</th><th className="num">Counted</th><th className="num">Variance</th><th>Email</th><th /></tr></thead>
          <tbody>{d?.rows.map((r) => (
            <tr key={r.id}><td>{r.closing_date}</td><td style={{ fontWeight: 600, color: "var(--ink)" }}>{r.username}</td><td className="num mono">{n0(r.total_transactions)}</td>
              <td className="num mono">{n0(r.expected_cash_balance)}</td><td className="num mono">{n0(r.actual_cash_count)}</td>
              <td className="num mono" style={{ color: vTone(r.cash_variance), fontWeight: 600 }}>{r.cash_variance > 0 ? "+" : ""}{n0(r.cash_variance)}</td>
              <td>{r.email_sent ? <span className="pill-tag ok">Sent</span> : <span className="pill-tag">No</span>}</td>
              <td><Link className="btn sm" to={`/end_of_day_details/${r.id}`}>Details</Link></td></tr>))}</tbody>
        </table>{d && d.rows.length === 0 && <div className="empty"><i className="fas fa-moon" />No closings in this period.</div>}</div>
        {d && <Pager page={d.page} totalPages={d.pages} onPage={(p) => setF({ ...f, page: p })} />}
      </section>
    </main>
  );
}
